import _get from 'lodash/get';
import base from './Base';

const themeColor = {
  primary: '#B9B309',
  secondary: '#00457C',

  // used for inner elements-specific to theme
  theme: '#B9B309',
};

const logo = {
  width: 200,
  height: 80,
  left: 32,
  top: 36,
  mobileWidth: 120,
  pageTileMarginTop: 0,
  default: `url(${_get(window.ORGBranding, 'defaultBrand.fleetPartners.logo.white')})`,
  colour: `url(${_get(window.ORGBranding, 'defaultBrand.fleetPartners.logo.colour')})`,
  white: `url(${_get(window.ORGBranding, 'defaultBrand.fleetPartners.logo.white')})`,
};

const dashboard = {
  driver: '#0b223d',
  vehicle: '#0b223d',
};

const theme = {
  ...base,
  color: { ...base.color, ...themeColor },
  dashboard,
  logo,
};

export default theme;



// WEBPACK FOOTER //
// ./src/themes/themes/FleetPartners.js